 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {computePosition, flip, shift} from '@floating-ui/dom'
import { posToDOMRect, ReactRenderer} from '@tiptap/react'









export const updatePosition = (editor, element) => {
  const virtualElement = {
    getBoundingClientRect: () =>
      posToDOMRect(editor.view, editor.state.selection.from, editor.state.selection.to)
  }

  computePosition(virtualElement, element, {
    placement: 'bottom-start',
    strategy: 'absolute',
    middleware: [shift(), flip()]
  }).then(({x, y, strategy}) => {
    element.style.width = 'max-content'
    element.style.position = strategy
    element.style.left = `${x}px`
    element.style.top = `${y}px`
  })
}

const renderSuggestion =
  (Component, options) =>
  () => {
    let component
    const handlePointerDown = (event) => {
      const element = _optionalChain([component, 'optionalAccess', _ => _.element])
      // Skip if the element doesn't exist or the event target is inside it
      if (!element || element.contains(event.target )) return
      _optionalChain([options, 'optionalAccess', _2 => _2.onHide, 'optionalCall', _3 => _3()])
    }
    return {
      onStart: (props) => {
        component = new ReactRenderer(Component, {
          props,
          editor: props.editor,
          className: 'z-10'
        }) 
        component.element.style.position = 'absolute'
        document.body.appendChild(component.element)
        document.addEventListener('pointerdown', handlePointerDown)
        updatePosition(props.editor, component.element)
      },

      onUpdate(props) {
        _optionalChain([component, 'optionalAccess', _4 => _4.updateProps, 'call', _5 => _5(props)])
        if (!_optionalChain([options, 'optionalAccess', _6 => _6.isPopupFixed])) {
          updatePosition(props.editor, component.element)
        }
      },

      onKeyDown(props) {
        if (props.event.key === 'Escape') {
          _optionalChain([options, 'optionalAccess', _7 => _7.onHide, 'optionalCall', _8 => _8()])
          component.destroy()
          return true
        }
        return _optionalChain([component, 'optionalAccess', _9 => _9.ref, 'optionalAccess', _10 => _10.onKeyDown, 'call', _11 => _11(props)])
      },

      onExit() {
        document.removeEventListener('pointerdown', handlePointerDown)
        component.element.remove()
        _optionalChain([component, 'optionalAccess', _12 => _12.destroy, 'call', _13 => _13()])
      }
    }
  }

export default renderSuggestion
